import React from 'react';
import PropTypes from 'prop-types';


const TruncateText = ({ text, numChars, forceBreak, truncateStart }) => {
  text = text || '';
  const clipped = truncateStart
    ? '…' + text.substring(text.length - numChars, text.length)
    : text.substring(0, numChars) + '…';

  return (
    <span style={{ wordBreak: forceBreak ? 'break-all' : 'normal' }}>
      {text.length <= numChars ? text : clipped}
    </span>
  );
};

TruncateText.propTypes = {
  text: PropTypes.string,
  numChars: PropTypes.number.isRequired,
  forceBreak: PropTypes.bool,
  truncateStart: PropTypes.bool,
};

export default TruncateText;
